import { useQuery, skipToken } from '@tanstack/react-query';
import {
  type OccasionPreferenceDietaryRestrictions,
  StatusCode,
} from '@hungryroot/rest';
import {
  getApiV2OccasionPreferenceOptions,
  getApiV2OccasionPreferenceOptionsPath,
} from '@hungryroot/rest/api/v2/occasion_preference_options/get/get-api-v2-occasion_preference_options';

const TIME_LIMIT = 5 * 60 * 1000;

export function useGetOccasionPreferences(
  dietaryRestriction?: OccasionPreferenceDietaryRestrictions
) {
  return useQuery({
    queryKey: [getApiV2OccasionPreferenceOptionsPath(), { dietaryRestriction }],
    queryFn: dietaryRestriction
      ? async () => {
          const resp = await getApiV2OccasionPreferenceOptions({
            dietaryRestriction,
          });

          if (resp.status !== StatusCode.SuccessOK) {
            throw new Error(JSON.stringify(resp.data, null, 2));
          }

          return resp.data;
        }
      : skipToken,
    gcTime: TIME_LIMIT,
    staleTime: TIME_LIMIT,
  });
}
